/**
 * Labstep
 *
 * @module core/Pagination/Count
 * @desc
 */

import type React from 'react';
import type { IPaginationCountProps } from './types';

export const PaginationCount: React.FC<IPaginationCountProps> = ({
  from,
  to,
  total,
}) => <span>{`Showing ${from}-${to} of ${total}`}</span>;
